// Static config for the wizard: copy keys and media. Labels live in i18n; option
// ids are shared with the profile and live in creator-profile/dnaOptions.

export const I18N_PREFIX = "pages.teacherOnboarding";

export const BODY_FONT = "'Inter Variable', 'Inter', sans-serif";
export const TITLE_FONT = "Poppins, sans-serif";

// SKEMA intro video shown on the welcome step (hosted on WordPress media).
// Picked by the current app locale, falling back to en.
export const SKEMA_VIDEO_URL: Record<string, string> = {
  en: "https://www.libertify.com/wp-content/uploads/2026/06/SKEMA-Unveil-2030_-Rethinking-Teaching-with-AI_compress.mp4",
  fr: "https://www.libertify.com/wp-content/uploads/2026/06/SKEMA-Unveil-2030_-Rethinking-Teaching-with-AI_FR_compress.mp4",
};

// Click-to-insert example prompts on the guardrail step (i18n keys under
// guardrail.examples.*).
export const GUARDRAIL_EXAMPLE_KEYS = [
  "example1",
  "example2",
  "example3",
  "example4",
  "example5",
  "example6",
  "example7",
  "example8",
] as const;
